import { createAction, props } from '@ngrx/store';
import {
	SubmissionTaskCommentModel,
	SubmissionTaskFilterModel,
	SubmissionTaskHistoryModel,
	SubmissionTaskModel,
	SubmissionTaskSearchModel,
	SubmissionTaskUpdateModel
} from '@twrx-api-models';
import {
	CreateSubmissionTaskCommentRequest,
	UpdateSubmissionTaskCommentRequest
} from 'app/models/dto/submission-task-comment-request';

import { ActionRequestPayload } from '../action-request-payload';
import { ActionResponsePayload } from '../action-response-payload';

export enum SubmissionOverviewActions {
	LoadSubmissionTasks = '[Submission Overview] LoadSubmissionTasks',
	SubmissionTasksLoaded = '[Submission Overview] SubmissionTasksLoaded',

	LoadSubmissionTask = '[Submission Overview] LoadSubmissionTask',
	SubmissionTaskLoaded = '[Submission Overview] SubmissionTaskLoaded',

	UpdateSubmissionTask = '[Submission Overview] UpdateSubmissionTask',
	SubmissionTaskUpdated = '[Submission Overview] SubmissionTaskUpdated',

	LoadSubmissionTaskHistory = '[Submission Overview] LoadSubmissionTaskHistory',
	SubmissionTaskHistoryLoaded = '[Submission Overview] SubmissionTaskHistoryLoaded',

	LoadSubmissionTaskComments = '[Submission Overview] LoadSubmissionTaskComments',
	SubmissionTaskCommentsLoaded = '[Submission Overview] SubmissionTaskCommentsLoaded',

	CreateSubmissionTaskComment = '[Submission Overview] CreateSubmissionTaskComment',
	SubmissionTaskCommentCreated = '[Submission Overview] SubmissionTaskCommentCreated',

	UpdateSubmissionTaskComment = '[Submission Overview] UpdateSubmissionTaskComment',
	SubmissionTaskCommentUpdated = '[Submission Overview] SubmissionTaskCommentUpdated',

	DeleteSubmissionTaskComment = '[Submission Overview] DeleteSubmissionTaskComment',
	SubmissionTaskCommentDeleted = '[Submission Overview] SubmissionTaskCommentDeleted',

	ErrorOccurred = '[Submission Overview] ErrorOccurred'
}

export const loadSubmissionTasks = createAction(
	SubmissionOverviewActions.LoadSubmissionTasks,
	props<ActionRequestPayload<SubmissionTaskFilterModel>>()
);

export const submissionTasksLoaded = createAction(
	SubmissionOverviewActions.SubmissionTasksLoaded,
	props<ActionResponsePayload<SubmissionTaskSearchModel[]>>()
);

export const loadSubmissionTask = createAction(
	SubmissionOverviewActions.LoadSubmissionTask,
	props<ActionRequestPayload<number>>()
);

export const submissionTaskLoaded = createAction(
	SubmissionOverviewActions.SubmissionTaskLoaded,
	props<ActionResponsePayload<SubmissionTaskModel>>()
);

export const updateSubmissionTask = createAction(
	SubmissionOverviewActions.UpdateSubmissionTask,
	props<ActionRequestPayload<SubmissionTaskUpdateModel>>()
);

export const submissionTaskUpdated = createAction(
	SubmissionOverviewActions.SubmissionTaskUpdated
);

export const loadSubmissionTaskHistory = createAction(
	SubmissionOverviewActions.LoadSubmissionTaskHistory,
	props<ActionRequestPayload<number>>()
);

export const submissionTaskHistoryLoaded = createAction(
	SubmissionOverviewActions.SubmissionTaskHistoryLoaded,
	props<ActionResponsePayload<SubmissionTaskHistoryModel[]>>()
);

export const loadSubmissionTaskComments = createAction(
	SubmissionOverviewActions.LoadSubmissionTaskComments,
	props<ActionRequestPayload<number>>()
);

export const submissionTaskCommentsLoaded = createAction(
	SubmissionOverviewActions.SubmissionTaskCommentsLoaded,
	props<ActionResponsePayload<SubmissionTaskCommentModel[]>>()
);

export const createSubmissionTaskComment = createAction(
	SubmissionOverviewActions.CreateSubmissionTaskComment,
	props<ActionRequestPayload<CreateSubmissionTaskCommentRequest>>()
);

export const submissionTaskCommentCreated = createAction(
	SubmissionOverviewActions.SubmissionTaskCommentCreated
);

export const updateSubmissionTaskComment = createAction(
	SubmissionOverviewActions.UpdateSubmissionTaskComment,
	props<ActionRequestPayload<UpdateSubmissionTaskCommentRequest>>()
);

export const submissionTaskCommentUpdated = createAction(
	SubmissionOverviewActions.SubmissionTaskCommentUpdated
);

export const deleteSubmissionTaskComment = createAction(
	SubmissionOverviewActions.DeleteSubmissionTaskComment,
	props<ActionRequestPayload<number>>()
);

export const submissionTaskCommentDeleted = createAction(
	SubmissionOverviewActions.SubmissionTaskCommentDeleted
);

export const errorOccurred = createAction(
	SubmissionOverviewActions.ErrorOccurred
);
